module.exports = __webpack_public_path__ + "media/images/area/feature/shikoku/related/th/5-0df6ad9f639e5bda737d0920b58bff73.jpg";